import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a triangle exclamation icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/triangle-exclamation?f=classic&s=solid
 */
export function TriangleExclamationIcon(props: CustomIconProps) {
  return <Icon icon={faTriangleExclamation} {...props} />;
}
